var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStage6Top(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_44157",
    "data-name": "Group 44157",
    xmlns: "http://www.w3.org/2000/svg",
    width: 195.934,
    height: 217.93,
    viewBox: "0 0 195.934 217.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9614",
    "data-name": "Path 9614",
    d: "M189.087,210.251c-.46,1.623-.86,6.215-1.5,12.172-.568,5.35-6.042,25.252-6.616,27.264-3.608,12.729-11.436,23.386-19.534,24.63-9.18,1.411-24.938,5.172-30.667,11.154-.119.124-.233.254-.346.389-5,6-7.227,16.012-18.09,17.2-10.868-1.184-13.1-11.2-18.1-17.2-.113-.135-.232-.271-.362-.4-5.734-5.972-21.476-9.732-30.651-11.143-8.1-1.244-15.931-11.376-19.539-24.111a53.686,53.686,0,0,1-1.379-6.183c-.573-3.538-4.663-16.255-5.231-21.6-.639-5.956-1.044-10.549-1.5-12.172-.773-2.732,37.483.336,76.762,4.182,39.274-3.846,77.524-6.913,76.751-4.182",
    transform: "translate(-14.47 -85.133)",
    fill: "#d3b1a7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9615",
    "data-name": "Path 9615",
    d: "M186.653,227.084l-5.139,17.581s-2.7,9.467-4.6,14.336-15.958,13.794-19.745,19.474-13.594,9.315-23.023,14.26c-.39.206-.8.395-1.239.573-4.241,1.736-10.744,2.385-16.9,2.553-6.161-.168-12.664-.817-16.9-2.553-.438-.178-.849-.368-1.239-.573-9.429-4.944-19.236-8.579-23.023-14.26S56.986,263.869,55.092,259s-4.6-14.336-4.6-14.336l-5.139-17.581L116,232.921Z",
    transform: "translate(-18.458 -92.407)",
    fill: "#efcabf"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9616",
    "data-name": "Path 9616",
    d: "M191.205,84.342C183.332,35,156.343.043,106.377.043h-.007C105.5.017,104.636,0,103.762,0,53.8,0,26.806,34.958,18.933,84.3c-5.661,35.478,7.636,60.036,30.113,76.222,4.208,3.03,10.723,5.14,17.13,6.939,10.28,6.5,18.186,11.853,36.38,12.508.2.008.394.013.594.017,1.054.032,2.132.053,3.257.053a26.461,26.461,0,0,0,3.394-.216c16.5-.988,24.182-6.09,33.92-12.252,6.484-1.813,13.11-3.938,17.371-7.007,22.477-16.186,35.774-40.744,30.113-76.222",
    transform: "translate(-7.173)",
    fill: "#060606"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9617",
    "data-name": "Path 9617",
    d: "M300.463,197.89s11.749-6.35,11.749,0-10.819,19.138-14.065,24.1-12.4,7.647-12.4,7.647Z",
    transform: "translate(-116.279 -79.379)",
    fill: "#e5bfb1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9618",
    "data-name": "Path 9618",
    d: "M11.748,190.593S0,184.243,0,190.593s10.819,19.139,14.065,24.1,12.4,7.646,12.4,7.646Z",
    transform: "translate(0.001 -76.409)",
    fill: "#e5bfb1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9619",
    "data-name": "Path 9619",
    d: "M174.895,176.7c-.07-.106-.142-.209-.216-.307-.162-.213-.334-.406-.5-.607l0,0h0a14.567,14.567,0,0,0-1.2-1.277c-7.466-8.167-18.366-23.808-55.335-22.378-31.339,1.213-46.7,12.221-53.247,18.991a17.327,17.327,0,0,0-4.133,5.286h0c-6.928,12.921-6.247,37.725-6.247,37.725l18.668,18.744s1.766.591,4.379,1.438c5.667,8.2,10.788,14.544,10.788,14.544l32.021,7.3c17.225,3.927,31.528-7.76,41.076-19.4,1.91-.623,3.131-1.033,3.131-1.033l18.668-18.745s.779-28.447-7.843-40.278",
    transform: "translate(-21.971 -61.866)",
    fill: "#efcabf"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9620",
    "data-name": "Path 9620",
    d: "M182.11,51.691c0,19.956-24.315,36.134-54.309,36.134S73.491,71.647,73.491,51.691,97.806,15.557,127.8,15.557,182.11,31.735,182.11,51.691",
    transform: "translate(-29.905 -6.331)",
    fill: "#efcabf"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11609",
    "data-name": "Path 11609",
    d: "M-11896.284-1860.218c-1.451,3.392-11.625,12.115-7.264,32.952s4.362,40.221-9.7,50.4,65.907,27.621,70.269,26.167,35.486-17.153,26.171-35.493-1.99-23.581,4.82-41.073-11.612-48.458-43.587-46.521S-11894.828-1863.61-11896.284-1860.218Z",
    transform: "translate(11956.202 1885.291)",
    fill: "#efcabf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage6Top);
export default __webpack_public_path__ + "static/media/stage6_top.1029163d5bb191da31da984400711194.svg";
export { ForwardRef as ReactComponent };